import request from '@/axios'

export function googleConnectAuth (customer_id) {
  return request({
    url:`google/connect/${customer_id}`,
    method:'GET'
  })
}

export function authorizationGoogle (customer_id, payload) {
  return request({
    url:`google/connect/${customer_id}`,
    method:'POST',
    data:payload
  })
}

// export function getGoogleDriveApi (customer_id) {
//   return request({
//     url:`google/google-calendar/connect/${customer_id}`,
//     method:'GET'
//   })
// }

export function getGoogleOauthToken (customer_id) {
  return request({
    url:`google/generated_client_secret/${customer_id}`,
    method:'GET'
  })
} 

export function getGoogleDownloadApi (customer_id, payload) {
  return request({
    url:`google/download/${customer_id}`,
    method:'POST',
    data:payload
  })
}export function getGoogleDownloadExcelApi (customer_id, payload) {
  return request({
    url:`google/download/local/${customer_id}`,
    method:'POST',
    data:payload
  })
}


export function getGoogleStatus (customer_id) {
  return request({
    url:`google/checkAuthorization/${customer_id}`,
    method:'GET'
  })
}


export function disconnectGoogleApi (customer_id) {
  return request({
    url:`google/revoke/${customer_id}`,
    method:'GET'
  })
}

export function googleCalConnect (customer_id,payload) {
  return request({
    url:`google/toggle/calender/${customer_id}`,
    method:'POST',
    data:payload
  })
}